import { useState, useCallback } from 'react';
import api from '../api';
import { QUALITY_SERVICE_API_URL } from '../config';

export default function useTestCaseDetail() {
  const [detail, setDetail]   = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState(null);

  const fetchById = useCallback((id) => {
    setLoading(true);
    setError(null);
    setDetail(null);
    api.get(`${QUALITY_SERVICE_API_URL}/hub/test-cases/${id}`)
      .then(res => setDetail(res.data))
      .catch(() => setError('Failed to load test case details.'))
      .finally(() => setLoading(false));
  }, []);

  const clear = useCallback(() => {
    setDetail(null);
    setError(null);
  }, []);

  return { detail, loading, error, fetchById, clear };
}
